// extracted by mini-css-extract-plugin
module.exports =  {"description":"gGABJbykmGXyfL4t9cWQ"};